/* CANIPANI — bande des races sur l'accueil.
 *
 * Meme source que le guide (races.json) : une seule verite, donc aucun risque
 * de divergence entre les deux pages. On montre les races les plus courantes
 * en France plutot que les premieres de l'alphabet — « Affenpinscher » en tete
 * de bande ne parle a personne.
 */
(function () {
  var racine = document.querySelector('[data-crace]');
  if (!racine) return;
  var rail = racine.querySelector('[data-crace-rail]');
  var max = parseInt(racine.getAttribute('data-crace-max'), 10) || 14;

  var COURANTES = [
    'Labrador retriever', 'Berger allemand', 'Golden retriever', 'Bouledogue français',
    'Cavalier king charles', 'Jack russell terrier', 'Border collie', 'Berger australien',
    'Chihuahua', 'Beagle', 'Cocker anglais', 'Shih tzu', 'Yorkshire terrier',
    'Husky sibérien', 'Rottweiler', 'Malinois', 'Teckel poil ras', 'Bouvier bernois',
    'Dogue de Bordeaux', 'Bichon frisé', 'Shiba inu', 'Épagneul breton',
    'Staffordshire bull terrier', 'Caniche moyen'
  ];

  var SIL = racine.getAttribute('data-crace-sil') || '';

  function carte(r) {
    var li = document.createElement('li');
    li.className = 'crace__item';
    // la silhouette du gabarit correspondant : elle dit d'un coup d'oeil
    // de quelle taille de chien on parle, ce qu'un nom de race ne fait pas
    var img = SIL ? '<img class="crace__chien" src="' + SIL.replace('__SIL__', r.sil || 'l') +
      '" alt="" width="120" height="120" loading="lazy" decoding="async">' : '';
    li.innerHTML =
      img +
      '<p class="crace__race">' + r.nom + '</p>' +
      '<p class="crace__lg">' + r.lg + ' cm couché</p>' +
      '<p class="crace__taille">' + r.taille + '</p>' +
      '<p class="crace__cm">' + r.cm + '</p>';
    return li;
  }

  fetch(racine.getAttribute('data-crace'))
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var index = {};
      d.forEach(function (r) { index[r.nom] = r; });
      var liste = [];
      COURANTES.forEach(function (n) { if (index[n] && liste.length < max) liste.push(index[n]); });
      // si la liste de reference ne suffit pas, on complete par ordre alphabetique
      for (var i = 0; i < d.length && liste.length < max; i++) {
        if (liste.indexOf(d[i]) === -1) liste.push(d[i]);
      }
      rail.innerHTML = '';
      liste.forEach(function (r) { rail.appendChild(carte(r)); });
    })
    .catch(function () { racine.setAttribute('data-erreur', '1'); });
})();
